<div class="data-table-container" [class.transparent]="transparent">
  <table class="data-table mat-table-custom">
    <!-- Header -->
    <thead>
      @if (groupedHeaders.length > 0) {
        <tr class="grouped-header-row">
          @for (group of groupedHeaders; track group) {
            <th
              scope="col"
              [attr.colspan]="group.colspan"
              [ngClass]="group.className || ''"
              [ngStyle]="{ 'text-align': group.align || 'center' }">
              {{ group.label }}
            </th>
          }
        </tr>
      }
      <tr>
        @for (column of columns; track column) {
          <th [ngStyle]="getColumnStyle(column)">
            @if (headerTemplate) {
              <ng-container [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletContext]="{ $implicit: column }"></ng-container>
            } @else {
              <div class="header-with-filter" [ngClass]="getHeaderClass(column)" [class.has-filter]="isColumnFilterVisible(column)">
                <div class="header-cell" [ngClass]="getHeaderClass(column)">
                  <div class="header-main">{{ column.header }}</div>
                  @if (column.headerSub) {
                    <div class="header-sub">{{ column.headerSub }}</div>
                  }
                </div>
                @if (isColumnFilterVisible(column)) {
                  <app-column-filter
                    [header]="column.header"
                    [options]="getFilterOptions(column)"
                    [selected]="columnFilters.get(column.key) ?? null"
                    (applied)="onColumnFilterApplied(column, $event)"
                    (cleared)="onColumnFilterCleared(column)">
                  </app-column-filter>
                }
              </div>
            }
          </th>
        }
      </tr>
    </thead>

    <!-- Body -->
    <tbody>
      <!-- Loading state -->
      @if (loading) {
        <tr class="status-row">
          <td [attr.colspan]="columns.length" class="loading">
            <span class="loading-spinner"></span>
            {{ loadingMessage }}
          </td>
        </tr>
      }


      <!-- Empty state -->
      @if (!loading && data.length === 0) {
        <tr class="status-row">
          <td [attr.colspan]="columns.length" class="empty">
            {{ emptyMessage }}
          </td>
        </tr>
      }


      @if (!loading && data.length > 0 && displayRows.length === 0) {
        <tr class="status-row">
          <td [attr.colspan]="columns.length" class="empty">
            No rows match the current filter
          </td>
        </tr>
      }

      <!-- Data rows -->
      @if (!loading && displayRows.length > 0) {
        <ng-container>
          @for (row of displayRows; let i = $index; track row) {
            @let rowIndex = dataIndexOf(i);
            <tr [ngClass]="getRowClasses(row, rowIndex, i)"
              [class.hoverable]="highlightOnHover"
              (click)="onRowClick(row, rowIndex)"
              (keydown.enter)="onRowClick(row, rowIndex)"
              (keydown.space)="onRowClick(row, rowIndex)"
              tabindex="0">

              @for (column of columns; track column) {
                <td
                  [ngStyle]="getColumnStyle(column)"
                  [class.editable-cell]="isCellEditable(column, row, rowIndex)"
                  [ngClass]="getCellClasses(row, column, rowIndex)">
                  @if (column.key === 'history') {
                    @if (getCellValue(row, column, rowIndex) === 'show') {
                      <button mat-icon-button class="history-button" title="Change Log"
                        (click)="$event.stopPropagation(); historyClick.emit(row)">
                        <mat-icon>history</mat-icon>
                      </button>
                    }
                    @if (getCellValue(row, column, rowIndex) !== 'show') {
                      <span>-</span>
                    }
                  } @else {
                    @if (isCellEditable(column, row, rowIndex)) {
                      <!-- Editable cell -->
                      <ng-container>
                        @if (column.type === 'currency') {
                          <!-- Currency input with mask -->
                          <input type="text"
                            class="cell-input"
                            appCurrencyInput
                            [decimalPlaces]="2"
                            [ngModel]="row[column.key]"
                            (ngModelChange)="onCurrencyValueChange(row, column, $event, rowIndex)"
                            (click)="$event.stopPropagation()">
                          } @else {
                            <!-- Other input types -->
                            <input [type]="getInputType(column)"
                              class="cell-input"
                              [value]="getEditValue(row, column)"
                              [step]="column.type === 'number' ? '1' : undefined"
                              (focus)="onEditFocus(row, column, $event)"
                              (input)="onValueChange(row, column, $event, rowIndex)"
                              (keydown)="onEditKeydown(column, $event)"
                              (blur)="onEditBlur(row, column)"
                              (click)="$event.stopPropagation()">
                            }
                          </ng-container>
                        } @else {
                          <!-- Read-only cell -->
                          @if (cellTemplate) {
                            <!-- Custom cell template if provided -->
                            <ng-container [ngTemplateOutlet]="cellTemplate" [ngTemplateOutletContext]="{ $implicit: row, column: column, value: row[column.key] }"></ng-container>
                          } @else {
                            <!-- Default cell content -->
                            <span [class.total-value]="hasTotalRow && rowIndex === totalRowIndex">
                              {{ getCellValue(row, column, rowIndex) }}
                            </span>
                          }
                        }
                      }
                    </td>
                  }
                </tr>
              }
            </ng-container>
          }
        </tbody>
      </table>
    </div>
